import(/* webpackMode: "eager" */ "/app/packages/frontend/app/[locale]/page.jsx");
